import { Component, Input } from '@angular/core';
import { TipoAssistenza } from '@app/shared/models/assistenza';

interface ITipoAssistenzaBadge {
  class: string;
  icon: string;
  label: string;
}

@Component({
  selector: 'ser-tipo-assistenza-badge',
  templateUrl: './tipo-assistenza-badge.component.html',
  styleUrl: './tipo-assistenza-badge.component.scss'
})
export class TipoAssistenzaBadgeComponent {

  @Input() type: TipoAssistenza = TipoAssistenza.AssistenzaCasse;
  @Input() value: number;
  @Input() valueMode: boolean = false;
  @Input() onlyIcon: boolean = false;

  styles: { [key in TipoAssistenza] : ITipoAssistenzaBadge } = {
    RimborsoScontriniDiCredito: { class: 'bg-danger', icon:'fa-receipt', label: 'rimborsoScontrinoDiCredito'  },
    AssistenzaCasse: { class: 'bg-success', icon:'fa-cash-register', label: 'assistenzaCasse'  },
    ScontrinoManuale: { class: 'bg-warning', icon:'fa-pencil', label: 'scontrinoManuale'  },
    DenaroRitrovato: { class: 'bg-info', icon:'fa-coins', label: 'denaroRitrovato' },
    Segnalazione: { class: 'bg-primary', icon:'fa-exclamation-triangle', label: 'segnalazione' }
  }

}
